import { render } from "./TalkFutureOfTopScreen.vue?vue&type=template&id=618fd51d&scoped=true&ts=true&lang=pug"
import script from "./TalkFutureOfTopScreen.vue?vue&type=script&lang=ts"
export * from "./TalkFutureOfTopScreen.vue?vue&type=script&lang=ts"

import "./TalkFutureOfTopScreen.vue?vue&type=style&index=0&id=618fd51d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618fd51d"]])

export default __exports__